<template>
  <v-app id="inspire" style="margin-left: 10%; margin-right: 10%;">
  <!--rgb(86, 147, 206)-->
    <v-app-bar color="rgb(0, 124, 186)" dark app fixed height="100">
      <v-img :src="require('@/assets/logo4.png')" max-height="90%" max-width="15%" contain class="mr-3"></v-img>
      <v-app-bar-title style="width: 10px" class="ml-0 pl-3"></v-app-bar-title>
      <div>
        <v-btn text :to="{ name: 'home' }" color= "white">
          <v-icon>home</v-icon> HOME
        </v-btn>
        
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text :to="{ name: 'especie' }" color="white" v-on="on"> BUSCADOR </v-btn>
          </template>
        </v-menu>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text :to="{ name: 'lista' }" color="white" v-on="on"> ESPECIES </v-btn>
          </template>
        </v-menu>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text color="white" v-on="on"> BIBLIOTECA </v-btn>
          </template>
          <v-list>
            <v-list-item :to="{ name: 'glosario' }">
              <v-list-item-title>Glosario</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'recursos' }">
              <v-list-item-title>Recursos</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text :to="{ name: 'recursos' }" color="white" v-on="on"> Recursos </v-btn>
          </template>
        </v-menu>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text :to="{ name: 'glosario' }" color="white" v-on="on"> Glosario </v-btn>
          </template>
        </v-menu> 
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text :to="{ name: 'contacto' }" color="white" v-on="on"> Contacto </v-btn>
          </template>
        </v-menu>-->
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text color="white" v-on="on"> CRÉDITOS </v-btn>
          </template>
          <v-list>
            <v-list-item :to="{ name: 'contacto' }">
              <v-list-item-title>Contacto</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'creditos' }">
              <v-list-item-title>Agradecimientos</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y open-on-hover v-if="userOid != null">
          <template v-slot:activator="{ on }">
            <v-btn text :to="{ name: 'administracion' }" color="white" v-on="on"> ADMIN </v-btn>
          </template>
          <v-list>
            <v-list-item :to="{ name: 'textura' }">
              <v-list-item-title>Textura</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'parenquima' }">
              <v-list-item-title>Parenquima</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'poros' }">
              <v-list-item-title>Poros</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'radios' }">
              <v-list-item-title>Radios</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'inclusiones' }">
              <v-list-item-title>Inclusiones</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'rol' }">
              <v-list-item-title>Rol</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'user' }"  v-if="rolOid === 1">
              <v-list-item-title>Usuarios</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
      
      <div class="d-flex align-center">
        <h3 style="color: white" v-if="userOid != null">{{ userName }}</h3>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text color="white" v-on="on">
              <v-icon>person</v-icon>
              <b v-if="userOid === null">Iniciar sesión</b>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="infoUser" v-if="userOid != null">
              <v-list-item-title>Información Personal</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" v-if="userOid != null">
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item>
            <v-list-item @click="signIn" v-if="userOid === null">
              <v-list-item-title>Iniciar sesión</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-main>
      <v-container fluid fill-height>
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>
    <v-footer color="rgb(15, 135, 201)" dark height="auto">
      <div class="d-flex flex-column flex-md-row text-center justify-space-between py-4 px-1 px-xl-1">
        <div class="text-white mb-3 mb-md-0" style="color: white">
          &copy;Desarrollado por el equipo de ITS - UNODC ROCOL - 2024 IDmaderas - Version 1.0.0.1 Privacy
        </div>
      </div>
    </v-footer>

    <v-dialog v-model="dialog_login" max-width="30%">
      <v-card>
          <div class="col-md-12 col-xl-12">
              <v-img :src="require('@/assets/logo2.png')" class="my-3" contain height="120" />
              <!-- <v-img :src="require('@/assets/logo2.png')" max-height="90%" max-width="15%" contain></v-img>
              <p style="font-size: 2rem; color: rgb(0, 30, 67)"><b>IdMaderas</b></p> -->
          </div>
          <v-card-title>
              <h2>Iniciar sesión</h2>
          </v-card-title>
          <v-card-text>
              <v-form ref="loginForm1" @submit.prevent="login1">
                  <v-text-field v-model="correo" label="Email" required></v-text-field>
                  <!-- <v-text-field v-model="code_login" label="Verification code" type="password" required></v-text-field> -->
                  <v-text-field v-model="pswd" label="Contraseña" type="password" required></v-text-field>
                  <!--<v-spacer></v-spacer>
                  <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_forgot">Recuperar contraseña</a>
                  <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_register">Register</a>-->
                  <v-btn style="color: black" x-large block type="submit" class="mt-2" :disabled="isValidForm1">Iniciar sesión</v-btn>                            
              </v-form>
          </v-card-text>
      </v-card>
    </v-dialog>
    <!--Dialogo para actualizar contraseña-->
    <v-dialog v-model="dialog_info" max-width="50%">
      <v-card>
          <v-card-title>
              <span class="text-h5">Información Personal</span>
          </v-card-title>
          <v-card-text>
              <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md3>
                        <v-text-field v-model="datoUser.identificacion" label="Identificacion" readonly disabled></v-text-field>
                    </v-flex>  
                    <v-flex xs12 sm12 md3>
                        <v-text-field v-model="datoUser.nombres" label="Nombres" readonly disabled></v-text-field>
                    </v-flex>                                            
                    <v-flex xs12 sm12 md3>
                        <v-text-field v-model="datoUser.apellidos" label="Apellidos" readonly disabled></v-text-field>
                    </v-flex>   
                    <v-flex xs12 sm12 md6>
                        <v-text-field v-model="datoUser.correo" label="Email" readonly disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                        <v-select v-model="datoUser.oid_rol" :items="rols" item-text="n_rol" item-value="oid" label="Rol" readonly disabled></v-select>
                    </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-text-field v-model="datoUser.pswd" :append-icon="verPswd ? 'visibility' : 'visibility'" 
                        :type="verPswd ? 'text' : 'password'" label="Contraseña Nueva" @click:append="verPswd = !verPswd" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-text-field v-model="pswdv" :append-icon="verPswd ? 'visibility' : 'visibility'" 
                        :type="verPswd ? 'text' : 'password'" label="Confirmar Contraseña" @click:append="verPswd = !verPswd" ></v-text-field>
                      </v-flex>
                  </v-layout>
              </v-container>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="guardar" :disabled="!isEnviar">Actualizar</v-btn>
              <v-btn v-if="datoUser.pswd_act === 1" color="secondary" text @click="cerrar_dialog_info">Cerrar</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialogo para Mensaje Validando Loginn-->
    <v-dialog v-model="dialog_cargando2" max-width="550px"> 
        <v-card>
            <v-card-title class="headline">Iniciando .....</v-card-title>
        </v-card>
    </v-dialog>
    <!-- Dialogo para Mensaje cargando-->
    <v-dialog v-model="dialog_guardando" max-width="550px"> 
        <v-card>
            <v-card-title class="headline">Guardando .....</v-card-title>
        </v-card>
    </v-dialog>
    <!-- Mensaje de confirmación-->
    <v-snackbar v-model="guardarExitoso" color="success" top>
        Guardado exitosamente
        <template v-slot:action="{ attrs }">
            <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Cerrar</v-btn>
        </template>
    </v-snackbar>
    <!-- Mensaje de confirmación-->
    <v-snackbar v-model="user_error" color="error" top>
            Usuario y/o contraseña incorrectas. Intente nuevamente.
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="user_error = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

  </v-app>
</template>

<script>
import axios from 'axios';


export default {
  name: "App",
  data() {
    return {
      datos: [],
      rols: [],
      datoUser: {
          oid: 0,
          identificacion:'',
          nombres: '',
          apellidos: '',
          correo: '',
          oid_rol: 1,
          pswd: '',
      },  
      correo: '',
      pswd: '',
      pswdv: '',
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire",
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      dialog_login: false,  
      acceso: 0,
      dialog_info: false,
      dialog_cargando2: false,
      dialog_guardando: false,
      guardarExitoso: false, 
      verPswd: false,
      user_error: false,
    };
  },
  computed: {
    userName() {
      // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
      const user = localStorage.getItem('userName'); 
      return user;
    },
    rolOid() {
    // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
        const oid_rol = localStorage.getItem('rolu');
        return Number(oid_rol);
    },    
    userOid() {
      // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
      const oid_usuario = localStorage.getItem('oidu');
      return oid_usuario;
    },
    isValidForm1() {
        return this.correo === true;
    },
    isEnviar() {
      if (this.pswdv ===this.datoUser.pswd ) {
          return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.listar();
    /*
    // Reinicia el temporizador cada vez que el usuario interactúe
    window.addEventListener('mousemove', this.resetSessionTimeout);
    window.addEventListener('keydown', this.resetSessionTimeout);
    this.startSessionTimeout();*/
  },
  methods:{
    async listar() {
        try {
            const response = await axios.get('api/Users/Listar');
            const responserol = await axios.get('api/Rols/Listar');

            this.datos = response.data;
            this.rols = responserol.data;
        } catch (error) {
            console.error(error);
        }
    },
    //FUNCIONES PARA INGRESAR
    async login1() {
        if (this.$refs.loginForm1.validate()) {
            // Limpiar el mensaje de error
            //this.error = '';
            try {
                // Realiza la petición HTTP a la API para autenticar al usuario
                const response = await axios.post('api/Logins/Login1', {
                    correo: this.correo,
                    pswd: this.pswd,
                    //code_login: this.code_login,
                });
                // Verificar si la autenticación fue exitosa (status 200)
                if (response.status === 200 && response.data.userName!=null) {
                    // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                    //const token = response.data.token;
                    const userName = response.data.userName;
                    const oid = response.data.oid;
                    const rol = response.data.rol;

                    // Almacenar el token en local storage o en una cookie para usarlo en futuras solicitudes
                    //localStorage.setItem('token', token);
                    localStorage.setItem('userName', userName);
                    localStorage.setItem('oidu', oid);
                    localStorage.setItem('rolu', rol);

                    // Iniciar temporizador de cierre de sesión (15 minutos)
                    //this.startSessionTimeout();
                    
                    // Cerrar el modal de login y recargar la página
                    this.dialog_login = false;
                    this.$router.replace({name:'/Home'});
                    window.location.reload();
                } 
                else {
                    // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                    this.aprobar =1;
                    this.user_error = true;
                }
            
            } catch (error) {
                // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                this.aprobar =1;
                this.user_error = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
            }
        }
    },
    async guardar(){
        this.dialog_guardando = true;
        // Validar los campos del formulario antes de guardar
        try {
            await axios.put('api/Users/actualizarPswd', this.datoUser);
            
            // Limpiar el formulario después de actualizar
            this.datoUser = { oid: 0, pswd: null };
            // Después de guardar exitosamente el registro:
            this.guardarExitoso = true;
            this.dialog_info = false;
            
        } catch (error) {
            console.error(error);
        } finally {
            // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
            this.dialog_guardando = false;
        }
    },
    async infoUser(dato) {
      const oid_usuario = Number(this.userOid);
      const response = await axios.get(`api/Users/Mostrar/${oid_usuario}`);
      this.datoUser = response.data;  
      this.dialog_info = true;
    },
    /*
    //METODOS PARA CERRAR SESION AUTOMATICAMENTE
    resetSessionTimeout() {
        clearTimeout(this.sessionTimeout);
        this.startSessionTimeout();
    },
    startSessionTimeout() {
        this.sessionTimeout = setTimeout(() => {
            this.logout();
        }, 900000); // 15 minutos
    },
    beforeDestroy() {
        window.removeEventListener('mousemove', this.resetSessionTimeout);
        window.removeEventListener('keydown', this.resetSessionTimeout);
    },*/
    logout() {        
      localStorage.removeItem('userName');
      localStorage.removeItem('oidu');
      localStorage.removeItem('rolu');          
      this.$router.replace({name:'/Home'});
      window.location.reload();
    },
    signIn() {
      this.dialog_login = true;
    },
    cerrar_dialog_login() {
        this.dialog_login = false;
    },
    cerrar_dialog_info(){
      this.dialog_info = false;
    }
  },
};
</script>
<style scoped>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }
</style>